import { jsx as u, jsxs as oe, Fragment as ue } from "react/jsx-runtime";
import { Icon as le } from "./icon.js";
import { IconButton as ae } from "./iconButton.js";
import W, { useTheme as Se } from "styled-components";
import Ie from "react";
import "@fcamna/shared-component-foundations";
import { u as fe } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { H as ge } from "./helperText-d9646f54.mjs";
import { L as $e } from "./label-33699561.mjs";
import { S as Ce } from "./screenReaderOnly-fd82ed96.mjs";
import "@fcamna/shared-icons";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./closeButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const P = 99999, k = -99999, be = "INCREMENT_SELECTOR_INPUT_ID";
function re(e) {
  var m, i, c, o, a, r, S, h;
  const t = Se(), n = {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  };
  switch (e) {
    case "small":
      n.width = (m = t.components.incrementSelector) == null ? void 0 : m.GetIconCSS.textSize.small.width, n.height = (i = t.components.incrementSelector) == null ? void 0 : i.GetIconCSS.textSize.small.height;
      break;
    case "medium":
      n.width = (c = t.components.incrementSelector) == null ? void 0 : c.GetIconCSS.textSize.medium.width, n.height = (o = t.components.incrementSelector) == null ? void 0 : o.GetIconCSS.textSize.medium.height;
      break;
    case "large":
      n.width = (a = t.components.incrementSelector) == null ? void 0 : a.GetIconCSS.textSize.large.width, n.height = (r = t.components.incrementSelector) == null ? void 0 : r.GetIconCSS.textSize.large.height;
      break;
    default:
      n.width = (S = t.components.incrementSelector) == null ? void 0 : S.GetIconCSS.textSize.default.width, n.height = (h = t.components.incrementSelector) == null ? void 0 : h.GetIconCSS.textSize.default.height;
  }
  return n;
}
const ze = W.div`
  display: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.Wrapper.display;
}};

  ${({ textSize: e, ...t }) => {
  var n, m, i, c, o, a;
  switch (e) {
    case "small":
      return `
          height: ${(n = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : n.Wrapper.textSize.small.height};
          width: ${(m = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : m.Wrapper.textSize.small.width};
        `;
    case "large":
      return `
          height: ${(i = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : i.Wrapper.textSize.large.height};
          width:${(c = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : c.Wrapper.textSize.large.width};
        `;
    case "medium":
    default:
      return `
          height: ${(o = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : o.Wrapper.textSize.medium.height};
          width: ${(a = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : a.Wrapper.textSize.medium.width}; 
        `;
  }
}};

  &:focus-visible {
    outline: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.Wrapper.focusVisible.outline;
}};
  }
`, xe = W.div`
  ${({ textSize: e, ...t }) => {
  var n, m, i, c, o, a;
  switch (e) {
    case "small":
      return `
          height: ${(n = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : n.IconComponent.textSize.small.height};
          width: ${(m = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : m.IconComponent.textSize.small.width};
        `;
    case "large":
      return `
          height: ${(i = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : i.IconComponent.textSize.large.height};
          width:${(c = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : c.IconComponent.textSize.large.width};
        `;
    case "medium":
    default:
      return `
          height: ${(o = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : o.IconComponent.textSize.medium.height};
          width: ${(a = t == null ? void 0 : t.theme.components.incrementSelector) == null ? void 0 : a.IconComponent.textSize.medium.width}; 
        `;
  }
}};

  display: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.display;
}};
  align-items: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.alignItems;
}};
  justify-content: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.justifyContent;
}};
  cursor: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.cursor;
}};
  position: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.position;
}};
  border-radius: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.borderRadius;
}};
  color: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.color;
}};

  &:hover {
    background-color: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.hover.backgroundColor;
}};
  }
  &:focus-visible {
    outline: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.focusVisible.outline;
}};
  }

  &.disabled {
    cursor: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.disabled.cursor;
}};
    color: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.disabled.color;
}};

    &:hover {
      background-color: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.disabled.hover.backgroundColor;
}};
    }
    &:focus-visible {
      outline: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.disabled.focusVisible.outline;
}};
    }
  }

  &.disabledPlusMinus {
    color: ${(e) => {
  var t;
  return (t = e.theme.components.incrementSelector) == null ? void 0 : t.IconComponent.disabledPlusMinus.color;
}};
  }
`, he = ({
  textSize: e = "medium",
  isDisabled: t = !1,
  isFullyDisabled: n = !1,
  children: m,
  variant: i,
  value: c = 0,
  min: o = k,
  max: a = P,
  onClick: r,
  accessibilityOptions: S = {},
  ...h
}) => {
  function f(l) {
    l.preventDefault(), l.stopPropagation(), !n && !t && (i === "subtract" && c - 1 >= o ? r == null || r(c - 1) : i === "add" && c + 1 <= a && (r == null || r(c + 1)));
  }
  return /* @__PURE__ */ u(
    ze,
    {
      textSize: e,
      ...h,
      children: /* @__PURE__ */ u(
        xe,
        {
          onClick: f,
          onKeyDown: (l) => {
            (l.code === "Enter" || l.code === "Space") && f(l);
          },
          className: `${n || t ? "disabled" : ""} ${t ? "disabledPlusMinus" : ""}`,
          textSize: e,
          ...S,
          children: m
        }
      )
    }
  );
}, mt = ({
  textSize: e = "medium",
  value: t = 0,
  isDisabled: n = !1,
  isFullyDisabled: m = !1,
  min: i = k,
  accessibilityOptions: c,
  ...o
}) => /* @__PURE__ */ u(
  he,
  {
    variant: "subtract",
    min: i,
    isFullyDisabled: m,
    isDisabled: n,
    value: t,
    textSize: e,
    ...o,
    children: /* @__PURE__ */ u(
      ae,
      {
        size: e,
        variant: "ghost",
        icon: /* @__PURE__ */ u(
          le,
          {
            name: "subtract",
            style: re(e),
            "aria-hidden": !0
          }
        ),
        accessibilityOptions: { ariaLabel: "Decrement value", ...c },
        isDisabled: n || m
      }
    )
  }
);
var $ = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.NONE = "none", e))($ || {});
const we = W.div`
  display: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.OuterWrapper.display;
}};
  flex-direction: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.OuterWrapper.flexDirection;
}};
  gap: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.OuterWrapper.gap;
}};
`, ye = W.div`
  border-radius: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.borderRadius;
}};
  position: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.position;
}};
  align-items: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.alignItems;
}};
  justify-content: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.justifyContent;
}};
  box-sizing: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.boxSizing;
}};
  padding: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.padding;
}};
  display: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.display;
}};
  gap: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.gap;
}};

  ${(e) => {
  var t, n, m;
  return `
      background-color: ${(t = e.theme.components.incrementSelector) == null ? void 0 : t.InnerWrapper.backgroundColor};
      border: ${(m = (n = e == null ? void 0 : e.theme.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InnerWrapper.border};
      `;
}}

  ${(e) => {
  var t, n, m, i, c, o;
  switch (e.textSize) {
    case "small":
      return `
          height: ${(t = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : t.InnerWrapper.textSize.small.height};
          width: ${(n = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : n.InnerWrapper.textSize.small.width};
        `;
    case "large":
      return `
          height: ${(m = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : m.InnerWrapper.textSize.large.height};
          width:${(i = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : i.InnerWrapper.textSize.large.width};
        `;
    case "medium":
    default:
      return `
          height: ${(c = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : c.InnerWrapper.textSize.medium.height};
          width: ${(o = e == null ? void 0 : e.theme.components.incrementSelector) == null ? void 0 : o.InnerWrapper.textSize.medium.width}; 
        `;
  }
}}
`, de = "UCL_IncrementSelector", it = ({
  value: e,
  label: t,
  textSize: n = "medium",
  helperText: m = "",
  isInvalid: i = !1,
  isDisabled: c = !1,
  onChange: o,
  children: a = [],
  min: r = k,
  max: S = P,
  htmlForId: h = be,
  labelProp: f,
  infoProp: l,
  trailingText: g,
  showRequiredIndicator: R = !1,
  inputState: b,
  helperTextProp: C,
  ...O
}) => {
  var x, w, y;
  const E = fe({ label: "Increment Selector" }), N = `${de}_label_id`;
  let I = b || $.NONE, d = C;
  b || (I = i ? $.ERROR : $.NONE), C ? (I === $.NONE && (I = ((x = C.secondaryProp) == null ? void 0 : x.state) === $.ERROR ? $.ERROR : $.NONE), d = {
    ...C,
    secondaryProp: {
      ...C.secondaryProp,
      state: I
    }
  }) : d = {
    [I === $.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: m,
      state: I
    }
  };
  const z = {
    defaultId: ((w = d == null ? void 0 : d.defaultProp) == null ? void 0 : w.id) || `default_${h}_message_id`,
    secondaryId: ((y = d == null ? void 0 : d.secondaryProp) == null ? void 0 : y.id) || `secondary_${h}_message_id`
  };
  return /* @__PURE__ */ oe(
    we,
    {
      ...O,
      ...E,
      children: [
        /* @__PURE__ */ u(
          $e,
          {
            labelProp: {
              label: t,
              showRequiredIndicator: R,
              id: N,
              htmlFor: h,
              ...f
            },
            infoProp: {
              infoText: "",
              infoType: "tooltip",
              popupTipHeader: "Info",
              ...l
            },
            trailingText: g
          }
        ),
        /* @__PURE__ */ u(
          ye,
          {
            isDisabled: c,
            textSize: n,
            children: a.map(
              (_, v) => Ie.cloneElement(_, {
                textSize: n,
                onClick: o,
                value: e,
                isFullyDisabled: c,
                inputState: I,
                htmlForId: h,
                min: r,
                max: S,
                key: `increment-selector-child-${v}`
              })
            )
          }
        ),
        /* @__PURE__ */ u(
          ge,
          {
            "data-testid": "helper-text_test",
            defaultProp: { id: z.defaultId, ...d.defaultProp },
            secondaryProp: { id: z.secondaryId, ...d.secondaryProp }
          }
        )
      ]
    }
  );
}, ct = ({
  textSize: e = "medium",
  value: t = 0,
  isDisabled: n = !1,
  isFullyDisabled: m = !1,
  max: i = P,
  accessibilityOptions: c,
  ...o
}) => /* @__PURE__ */ u(
  he,
  {
    variant: "add",
    max: i,
    isFullyDisabled: m,
    isDisabled: n,
    value: t,
    textSize: e,
    ...o,
    children: /* @__PURE__ */ u(
      ae,
      {
        size: e,
        variant: "ghost",
        icon: /* @__PURE__ */ u(
          le,
          {
            name: "add",
            style: re(e),
            "aria-hidden": !0
          }
        ),
        isDisabled: n || m,
        accessibilityOptions: { ariaLabel: "Increment value", ...c }
      }
    )
  }
), We = W.input`
  display: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.display;
}};
  box-sizing: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.boxSizing;
}};
  padding: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.padding;
}};
  justify-content: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.justifyContent;
}};
  align-items: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.alignItems;
}};
  gap: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.gap;
}};
  flex-shrink: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.flexShrink;
}};

  border-radius: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.borderRadius;
}};

  overflow: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.overflow;
}};
  color: ${({ disabled: e, theme: t }) => e ? t.components.incrementSelector.InputComponent.color.disabled : t.components.incrementSelector.InputComponent.color.default};
  text-align: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.textAlign;
}};
  text-overflow: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.textOverflow;
}};
  white-space: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.whiteSpace;
}};
  font-style: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.fontStyle;
}};
  -moz-appearance: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.mozAppearance;
}};

  border: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.border;
}};
  background-color: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.backgroundColor;
}};

  &::-webkit-inner-spin-button {
    display: ${(e) => {
  var t, n, m;
  return (m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.webkitInnerSpinButton.display;
}};
  }

  outline: ${({ inputState: e, disabled: t, theme: n }) => {
  var m, i;
  return !t && ((i = (m = n == null ? void 0 : n.components) == null ? void 0 : m.incrementSelector) == null ? void 0 : i.InputComponent.outline[e || "none"]);
}};

  ${(e) => {
  var t, n, m, i, c, o, a, r, S, h, f, l, g, R, b, C, O, E, N, I, d, z, x, w, y, _, v, G, j, L, M, T, H, A, D, V, B, s, U, q, K, X, F, Q, J, Y, Z, p, ee, te, ne, me, ie, ce;
  if (e.textSize === "small")
    return `
          width: ${(m = (n = (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components) == null ? void 0 : n.incrementSelector) == null ? void 0 : m.InputComponent.textSize.small.width}; 
          height: ${(o = (c = (i = e == null ? void 0 : e.theme) == null ? void 0 : i.components) == null ? void 0 : c.incrementSelector) == null ? void 0 : o.InputComponent.textSize.small.height}; 
          font-family: ${(S = (r = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : r.incrementSelector) == null ? void 0 : S.InputComponent.textSize.small.fontFamily}; 
          font-weight: ${(l = (f = (h = e == null ? void 0 : e.theme) == null ? void 0 : h.components) == null ? void 0 : f.incrementSelector) == null ? void 0 : l.InputComponent.textSize.small.fontWeight}; 
          font-size: ${(b = (R = (g = e == null ? void 0 : e.theme) == null ? void 0 : g.components) == null ? void 0 : R.incrementSelector) == null ? void 0 : b.InputComponent.textSize.small.fontSize}; 
          line-height: ${(E = (O = (C = e == null ? void 0 : e.theme) == null ? void 0 : C.components) == null ? void 0 : O.incrementSelector) == null ? void 0 : E.InputComponent.textSize.small.lineHeight};
      `;
  if (e.textSize === "medium")
    return `
        width:  ${(d = (I = (N = e == null ? void 0 : e.theme) == null ? void 0 : N.components) == null ? void 0 : I.incrementSelector) == null ? void 0 : d.InputComponent.textSize.medium.width}; 
        height:${(w = (x = (z = e == null ? void 0 : e.theme) == null ? void 0 : z.components) == null ? void 0 : x.incrementSelector) == null ? void 0 : w.InputComponent.textSize.medium.height}; 
        font-family: ${(v = (_ = (y = e == null ? void 0 : e.theme) == null ? void 0 : y.components) == null ? void 0 : _.incrementSelector) == null ? void 0 : v.InputComponent.textSize.medium.fontFamily}; 
        font-weight: ${(L = (j = (G = e == null ? void 0 : e.theme) == null ? void 0 : G.components) == null ? void 0 : j.incrementSelector) == null ? void 0 : L.InputComponent.textSize.medium.fontWeight}; 
        font-size: ${(H = (T = (M = e == null ? void 0 : e.theme) == null ? void 0 : M.components) == null ? void 0 : T.incrementSelector) == null ? void 0 : H.InputComponent.textSize.medium.fontSize};
        line-height:  ${(V = (D = (A = e == null ? void 0 : e.theme) == null ? void 0 : A.components) == null ? void 0 : D.incrementSelector) == null ? void 0 : V.InputComponent.textSize.medium.lineHeight};
      `;
  if (e.textSize === "large")
    return `
          width: ${(U = (s = (B = e == null ? void 0 : e.theme) == null ? void 0 : B.components) == null ? void 0 : s.incrementSelector) == null ? void 0 : U.InputComponent.textSize.large.width};
          height:${(X = (K = (q = e == null ? void 0 : e.theme) == null ? void 0 : q.components) == null ? void 0 : K.incrementSelector) == null ? void 0 : X.InputComponent.textSize.large.height};
          font-family: ${(J = (Q = (F = e == null ? void 0 : e.theme) == null ? void 0 : F.components) == null ? void 0 : Q.incrementSelector) == null ? void 0 : J.InputComponent.textSize.large.fontFamily}; 
          font-weight: ${(p = (Z = (Y = e == null ? void 0 : e.theme) == null ? void 0 : Y.components) == null ? void 0 : Z.incrementSelector) == null ? void 0 : p.InputComponent.textSize.large.fontWeight}; 
          font-size: ${(ne = (te = (ee = e == null ? void 0 : e.theme) == null ? void 0 : ee.components) == null ? void 0 : te.incrementSelector) == null ? void 0 : ne.InputComponent.textSize.large.fontSize};
          line-height: ${(ce = (ie = (me = e == null ? void 0 : e.theme) == null ? void 0 : me.components) == null ? void 0 : ie.incrementSelector) == null ? void 0 : ce.InputComponent.textSize.large.lineHeight};
      `;
}};

  &:hover {
    outline: ${({ inputState: e, disabled: t, theme: n }) => !t && n.components.incrementSelector.InputComponent.hover.outline[e || "none"]};
  }

  &:focus-visible {
    outline: ${({ inputState: e, theme: t }) => t.components.incrementSelector.InputComponent.focusVisible.outline[e || "none"]};
  }
`, ot = ({
  textSize: e = "medium",
  value: t = 0,
  isFullyDisabled: n = !1,
  onClick: m,
  min: i = k,
  max: c = P,
  isInvalid: o = !1,
  htmlForId: a,
  isRequired: r = !1,
  ...S
}) => {
  function h(l) {
    if (l.key !== "Tab" && (t.toString().length === 1 && l.key === "Backspace" || /[^0-9-]/.test(l.key) && l.key !== "Backspace" && l.key !== "ArrowLeft" && l.key !== "ArrowRight"))
      return l.stopPropagation(), l.preventDefault(), !1;
  }
  function f(l) {
    if (!n) {
      const g = parseInt(l.currentTarget.value);
      g < i || g > c || isNaN(g) ? m == null || m(t) : m == null || m(g);
    }
  }
  return /* @__PURE__ */ oe(ue, { children: [
    /* @__PURE__ */ u(
      We,
      {
        "aria-labelledby": `${de}_label_id`,
        textSize: e,
        isInvalid: o,
        type: "number",
        value: t,
        onKeyDown: h,
        onChange: f,
        disabled: n,
        "aria-required": r,
        ...S,
        id: a
      }
    ),
    /* @__PURE__ */ u(Ce, { "aria-live": "assertive", children: t })
  ] });
};
export {
  mt as DecrementStepper,
  it as IncrementSelector,
  ct as IncrementStepper,
  ot as NumberInputField
};
